export default __webpack_public_path__ + "static/media/img21.15af640c.svg";